<!--分析中表内容的展示-->
<template>
  <div v-loading="tableLoading" style="min-height: 515px">
<!--    {{folder}}-->
    <p style="white-space: pre-line;text-indent: 2em;padding: 10px" v-if="getIntro(fileName,folder)"
       v-html="getIntro(fileName,folder)"></p>
    <el-dropdown style="margin-bottom: 15px" trigger="click" @command="downTable">
      <el-tooltip :content="'下载'+fileName.substring(0,fileName.length-4)+'文件'" placement="top">
        <el-button type="primary" size="small" style="margin: 2px"
        >下载
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
      </el-tooltip>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="xls">下载xls格式</el-dropdown-item>
        <el-dropdown-item command="xlsx">下载xlsx格式</el-dropdown-item>
        <el-dropdown-item command="txt">下载txt格式</el-dropdown-item>
        <el-dropdown-item command="csv">下载csv格式</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
<!--    //引入具体的表格-->
    <table id="table" class="tableInformation table table-bordered" data-advanced-sortable="true"
           data-pagination="true" style="margin-top:5px;" ref="table">
    </table>

    <el-dialog
      title="下载表格"
      :visible.sync="dialogVisible"
      width="30%">
      <span>请选择要下载的列</span><br>
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
                   style="margin-top: 20px">全选
      </el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkedCols" @change="handleCheckedColsChange">
        <el-checkbox v-for="col in cols" :label="col" :key="col">{{ col }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitDown">确定下载</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
import $ from 'jquery'
import '../jquery/jQuery-3.2.1'
import '../jquery/bootstrap'
import '../jquery/select2'
import '../jquery/bootstrap-table'
import '../jquery/bootstrap-table-zh-CN.min'
import '../jquery/bootstrap-advanced-sortable'
import {introduce, note} from "@/utils/notes";
import {getDataInLocalStorage} from "@/utils/localStorageUtils";

const baseURL = process.env.VUE_APP_BASE_API
$('.dropdown-toggle').dropdown()
export default {
  name: "TableDetail",
  props: {
    analyzeId: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: ""
    },
    projectId: {
      type: String,
      default: ""
    },
    folder: {
      type: String,
      default: ""
    },
    fileName: {
      type: String,
      default: ''
    },
    floor: {
      type: String,
      default: ''
    },
    passGroupSampleName:{}
  },
  mounted() {
    let that = this
    this.getData()
      .then(x => {
        that.tableLoading = false
      })
    this.checkTableRendered()

  },
  data() {
    return {
      tableLoading: true,
      headFile: [],
      titleName: '',
      tableKey: '',
      dialogVisible: false,
      checkAll: false,
      checkedCols: [],
      cols: [],
      isIndeterminate: true,
      type: '',
      tableData: [],
      groupSampleName: {}
    }
  },
  methods: {
    checkTableRendered() {
      if (this.$refs.table) {
        if (this.$refs.table.querySelectorAll('tbody tr').length > 0) {
          this.$emit("getTableLoading")
        } else {
          setTimeout(() => {
            this.checkTableRendered();
          }, 1000); // 每隔100毫秒重新检查一次
        }
      }
    },
    async getAnalyzeGroupSampleNames() {
      const res = await this.$http.get("/analyze/textContent/" + this.analyzeId).catch(error => {
        this.$messageUi.error("组名，样本名获取失败")
      })
      if (res) {
        if (res.code === 200) {
          var groupSampleName = {
            sampleName: res.data.sampleNames,
            groupName: res.data.groupNames
          }
          return groupSampleName
        } else {
          return ""
        }
      }
    },
    async getData() {
      if (this.folder !== '') {
        const res = await this.$http.get("/preview/tableData/" + this.projectId + "/" + this.analyzeId + "/" + this.folder).catch(error => {
          this.$message.error("请刷新界面")
        })
        if(res){
          if (res.code === 200) {
            let data = res.data
            this.headFile = res.data[0]
            // const groupSampleName = await this.getAnalyzeGroupSampleNames()
            const groupSampleName = this.passGroupSampleName
            // return data
            if (data && groupSampleName) {
              this.table(data, groupSampleName)
            }
          } else {
            this.$messageUi('数据异常')
          }
        }
      }
    },
    table(data, groupSampleName) {
      let filedName = Object.keys(this.headFile).sort()
      filedName.forEach(x => {
        data = JSON.parse(JSON.stringify(data).replaceAll(x, x.substring(4, x.length)))
      })
      let columns = []
      for (let i = 0; i < filedName.length; i++) {
        let titleName = filedName[i].substring(4, filedName[i].length)
        columns.push({
          field: titleName,
          title: titleName,
          sortable: true,
          searchType: "text",
        })
      }
      var datas = []
      for (var i = 0; i < data.length; i++) {
        datas.push(data[i])
      }
      let fileNames = this.fileName
      var that = this
      $(this.$refs.table).bootstrapTable("destroy").bootstrapTable({
        data: datas,
        columns: columns,
        fileNames: fileNames,
        groupSampleNames: groupSampleName
      })
    },
    // 点击下载表格的按钮
    downTable(type) {
      this.type = type
      this.dialogVisible = true
      this.cols = []
      Object.keys(this.headFile).sort().forEach(key => {
        this.cols.push(key.substring(4, key.length))
      })
    },
    //表格列的多选
    handleCheckAllChange(val) {
      this.checkedCols = val ? this.cols : [];
      this.isIndeterminate = false;
    },
    handleCheckedColsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cols.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cols.length;
    },
    //下载表格数据
    async submitDown() {
      if (this.checkedCols.length > 0) {
        let indexArr = []
        let head = this.cols
        this.checkedCols.forEach(function (item) {
          for (let i = 0; i < head.length; i++) {
            if (head[i] === item) {
              indexArr.push(i + 1)
            }
          }
        })
        indexArr.sort()
        const arr = JSON.stringify(indexArr)
        // const res = await this.$http({
        //   method: 'post',
        //   url: '/preview/downloadTableData/' + this.projectId + '/' + this.analyzeId + '/' + this.type + '/' + this.folder,
        //   data: indexArr,
        //   responseType: "blob",
        // })
        const url = `${baseURL}/preview/downloadTableData/${this.projectId}/${this.analyzeId}/${this.type}/${this.folder}?data=${arr}&token=${getDataInLocalStorage("token")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        this.dialogVisible = false
        document.body.removeChild(elink);
      } else {
        this.$messageUi('请选择要下载的列名')
      }
    },
    getNotice(folder) {
      return note(folder)
    },
    getIntro(fileName, folder) {
      return introduce(fileName, folder)
    },

  },


}
$(function () {
  // 解决bootstrap下拉菜单第一次点击无反应问题
  $('.dropdown-toggle').dropdown();
});

</script>
<style scoped>
/*@import "../../public/bootstrap-3.3.7/css/bootstrap.min.css";*/
/*@import "../../public/bootstrap-advanced-sortable/bootstrap-table.min.css";*/
/*@import '../../public/bootstrap-advanced-sortable/bootstrap-advanced-sortable.css';*/
@import '../assets/js/bootstrap-3.3.7/css/bootstrap.min.css';
@import '../assets/js/bootstrap-advanced-sortable/bootstrap-table.min.css';
@import '../assets/js/bootstrap-advanced-sortable/bootstrap-advanced-sortable.css';

</style>
<style scoped>
.dropdown-menu li {
  background: white;
}

::v-deep .fixed-table-body {
  overflow-x: auto;
}

/deep/ .el-dialog__header {
  /*background-color: #477cb2;*/
  /*border-bottom: 1px solid #d5d4d4;*/
}

/*/deep/ .el-dialog__title {*/
/*  color: white;*/
/*}*/

</style>
